<template>
    
          <div>
           
            <h3 class="mt-2">Individual Analysis Report</h3>
            <h3 class="text-blue-heading mt-5">{{ trainingDetails.title }}</h3>
  
            <div class="row mt-5">
              <div class="col-sm-6">
                <h5>Select an individual to view</h5>
                ({{ allTrainees.length }})
              </div>
              <div class="col-sm-6">
                <h5>Hints</h5>
                <span class="text-success">Green: Correct</span> ,
                <span class="text-danger">Red: Incorrect</span>
              </div>
            </div>
            <!-- ------------------------------------- -->
            <div class="row">
              <div class="col-sm-3 mt-5" v-if="allTrainees">
                <div v-for="(trainee, tIndex) in allTrainees" v-bind:key="tIndex">
                  <h5
                    :id="trainee.trainee.user_trainee_id"
                    class="text-blue font-weight-bold common_trigger"
                    v-if="trainee.trainee.userstrainee.name && tIndex == 0"
                    @click="loadAssesment(trainee.trainee.user_trainee_id)"
                  >
                    {{ trainee.trainee.userstrainee.name }}
                  </h5>
                  <h5
                    :id="trainee.trainee.user_trainee_id"
                    v-else-if="tIndex > 0 && trainee.trainee.userstrainee.name"
                    class="common_trigger"
                    @click="loadAssesment(trainee.trainee.user_trainee_id)"
                  >
                    {{ trainee.trainee.userstrainee.name }}
                  </h5>
                </div>
              </div>
              <div class="col-sm-6 col-md-6 mt-5">
                <div
                  v-for="(question, qIndex) in Assesment"
                  v-bind:key="qIndex + 5"
                >
                  <h6 class="pointer-class">
                    <b>Q{{ qIndex + 1 }}. {{ question.question.title }}</b>
                  </h6>
                  <div class="d-flex justify-content-start ">
                    <div
                      class=""
                      v-for="(pre, preIndex) in preFeedback"
                      v-bind:key="preIndex + 2"
                    >
                      <div
                        class="pr-5"
                        v-if="question.question_id == pre.question_id"
                      >
                        <h6 class="mt-2 mb-0">Pre Assessment</h6>
                        <p
                          class="text-success"
                          v-if="pre.options && pre.options.status == 1"
                        >
                          <span> </span>
                          {{ pre.options.title }}
                        </p>
                        <p class="text-danger" v-else>
                          <span> </span>
                          {{ pre.options.title }}
                        </p>
                      </div>
                    </div>
                    <div
                      v-for="(post, prpkIndex) in postFeedback"
                      v-bind:key="'post' + prpkIndex + 1"
                    >
                      <div
                        class=""
                        v-if="post.question_id == question.question_id"
                      >
                        <h6 class="mt-2 mb-0">Post Assessment</h6>
                        <p
                          class="text-success"
                          v-if="post.options && post.options.status == 1"
                        >
                          <span> </span>
                          {{ post.options.title }}
                        </p>
                        <p class="text-danger" v-else>
                          <span> </span>
                          {{ post.options.title }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-3 col-md-3 mt-5">
                <div class="row">
                  <!--start  -->
                  <div class="col-sm-8 col-md-11">
                    <h6 class="mt-3 text-dark text-center" style="">
                      Knowledge Change
                    </h6>
                    <div
                      id="average-actual-knowledge-change"
                      style="height: 300px; width: 100%;"
                      class="print-actual-graph"
                    ></div>
                  </div>
                  <!--end -->
                </div>
              </div>
            </div>
            <!-- ------------------------------------- -->
          </div>
        
  </template>
  
  <script>
  
  import axios from "axios";
  import Highcharts from "../../../public/highcharts";
  import $ from 'jquery';
  
  export default {
    data: () => ({
      isActve1: 1,
      trainingCode: "",
      trainingID: "",
      allTrainees: [],
      trainingDetails: [],
      Questions: [],
      preFeedback: [],
      postFeedback: [],
      PostQuestions: [],
      PreSelection: [],
      Assesment: [],
      PostSelection: [],
      isSidebar: false,
      colorx: "warning",
      TotalQuestions:0,
      TruePreQuestion:0,
      TruePostQuestion:0,
    }),
    
    created() {},
    methods: {
      showTraineesPreAssesment: function showTraineesPreAssesment(
        tId,
        traineeuserId
      ) {
        axios
          .get(
            process.env.VUE_APP_BASE_PATH +
              "/show/trainee-preassesment/report/" +
              traineeuserId +
              "/" +
              tId
  
          )
          .then(response => {
            if(response.data.unAuth){
              this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
              localStorage.clear();
              setTimeout(() => {
                  this.$router.push("/");
              }, 1000);
  
            }
            if(response.data.tokenExpired){
              this.$toasted.global.errorMsg(response.data.tokenExpired);
              localStorage.clear();
              setTimeout(() => {
                  this.$router.push("/");
              }, 1000);
            }
            this.closeLoading();
            if (response.data) {
              this.preFeedback = response.data.prefeedback;
              this.Assesment = response.data.assesment;
               this.TotalQuestions = response.data.assesment.length;
              this.preAssesmentData();
              this.knowledgeChart();
            }
          });
      },
      showTraineesPostAssesment: function showTraineesPostAssesment(
        tId,
        traineeuserId
      ) {
        axios
          .get(
            process.env.VUE_APP_BASE_PATH +
              "/show/trainee-postassesment/report/" +
              traineeuserId +
              "/" +
              tId
  
          )
          .then(response => {
            if(response.data.unAuth){
              this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
              localStorage.clear();
              setTimeout(() => {
                  this.$router.push("/");
              }, 1000);
  
            }
            if(response.data.tokenExpired){
              this.$toasted.global.errorMsg(response.data.tokenExpired);
              localStorage.clear();
              setTimeout(() => {
                  this.$router.push("/");
              }, 1000);
            }
            this.closeLoading();
            if (response.data) {
              this.postFeedback = response.data.prefeedback;
              this.postAssesmentData();
              this.knowledgeChart();
            }
          });
      },
      loadAssesment(trainee_id) {
        $(".common_trigger").removeClass("text-blue font-weight-bold");
        $("#" + trainee_id).addClass("text-blue font-weight-bold");
  
        this.openLoading();
        this.showTraineesPreAssesment(this.trainingID, trainee_id);
        this.showTraineesPostAssesment(this.trainingID, trainee_id);
        this.closeLoading();
      },
      showTrainees: function showTrainees(tId) {
        axios
          .get(
            process.env.VUE_APP_BASE_PATH +
              "/single/training/traineedetails/report/get/" +
              tId
  
          )
          .then(response => {
            if(response.data.unAuth){
              this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
              localStorage.clear();
              setTimeout(() => {
                  this.$router.push("/");
              }, 1000);
  
            }
            if(response.data.tokenExpired){
              this.$toasted.global.errorMsg(response.data.tokenExpired);
              localStorage.clear();
              setTimeout(() => {
                  this.$router.push("/");
              }, 1000);
            }
            this.closeLoading();
            this.allTrainees = response.data.trainees;
            //load first trainee assesment
            if (
              this.allTrainees &&
              this.allTrainees[0] != undefined &&
              this.allTrainees[0].trainee != undefined
            ) {
              this.showTraineesPreAssesment(
                tId,
                this.allTrainees[0].trainee.user_trainee_id
              );
              this.showTraineesPostAssesment(
                tId,
                this.allTrainees[0].trainee.user_trainee_id
              );
            }
          });
      },
      openLoading() {
        this.$vs.loading({
          type: "material"
        });
      },
      closeLoading() {
        this.$vs.loading.close();
      },
      preAssesmentData() {
           this.TruePreQuestion = 0;
           if (this.preFeedback) {
                 this.preFeedback.map(item => {
                    if(item.options.status === "1") {
                        this.TruePreQuestion++;
                      }
                 });
              }
        },
      postAssesmentData() {
           this.TruePostQuestion = 0;
           if (this.postFeedback) {
                 this.postFeedback.map(item => {
                     if (item.options.status === "1") {
                           this.TruePostQuestion++;
                      }
                 });
              }
       },
  
  
      knowledgeChart() {
        Highcharts.chart("average-actual-knowledge-change", {
                chart: {
                  type: "column",
                },
  
                accessibility: {
                  announceNewData: {
                    enabled: true,
                  },
                },
                xAxis: {
                  type: "category",
                },
                yAxis: { min: 0,
                        max: 100,   // y-axis ko fix karna 0 se 100 tak
                        title: {
                          text: ""
                        }},
                legend: {
                  enabled: false,
                },
                plotOptions: {
                  series: {
                    borderWidth: 0,
                    dataLabels: {
                    enabled: true,
                      format: "{point.y:.1f}%",
  
                    }
                  },
                },
  
                tooltip: {
                  // headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                  pointFormat:
                    '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> <br/>',
                },
  
                series: [
                  {
                    // name: "",
                    colorByPoint: true,
                    data: [
                      {
                        name: "Pre Assessment",
                        y: (this.TruePreQuestion/this.TotalQuestions)*100,
                        color: "#80ff80"
                      },
                      {
                        name: "Post Assessment",
                        y: (this.TruePostQuestion/this.TotalQuestions)*100,
                        color: "#63b94b",
                      },
                    ],
                  },
                ],
              });
       }
  
    },
     mounted() {
     axios.defaults.headers['Authorization'] = localStorage.getItem('token')
      this.trainingCode = this.$route.query.trainingId;
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/programOfficer/trainingsingle/get/" +
            this.trainingCode
  
          )
          .then(response => {
            if(response.data.unAuth){
              this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
              localStorage.clear();
              setTimeout(() => {
                  this.$router.push("/");
              }, 1000);
  
            }
            if(response.data.tokenExpired){
              this.$toasted.global.errorMsg(response.data.tokenExpired);
              localStorage.clear();
              setTimeout(() => {
                  this.$router.push("/");
              }, 1000);
            }
          this.closeLoading();
          if (response.data && response.data.training) {
            this.trainingDetails = response.data.training;
            this.trainingID = response.data.training.id;
            this.showTrainees(response.data.training.id);
          }
        });
    }
  };
  </script>
  
  <style scoped>
  .text-blue {
    color: #00a4ea;
  }
  .btn-report {
    background-color: #6488d2 !important;
    border-radius: 0px !important;
    padding: 3px 30px !important;
  }
  .text-blue {
    color: #00a4ea;
    cursor: pointer !important;
    background-color: rgba(60, 60, 250, 0.055);
  }
  .text-blue-heading {
    color: #00a4ea;
  }
  h5 {
    cursor: pointer;
  }
  h5:hover {
    background-color: rgba(60, 60, 250, 0.178);
  }
  </style>
  